module.exports = __webpack_public_path__ + "img/Bou.d7fadee6.gif";